<template>
  <div class="cart-order-block__delivery cart-order-delivery">
    <div class="cart-order-block__field">
      <TheCartDaDataAddress/>
      <ItemErrors :errors="errors.addressOk"/>

      <TheCartOrderReceivingPickup v-if="isAddressOk"/>
    </div>

  </div>
</template>

<script>
import ItemErrors from "./ItemErrors.vue";
import TheCartDaDataAddress from "./TheCartDaDataAddress.vue";
import TheCartOrderReceivingPickup from "./TheCartOrderReceivingPickup.vue";

export default {
  name: "TheCartOrderReceivingDelivery",
  components: {
    TheCartOrderReceivingPickup,
    TheCartDaDataAddress,
    ItemErrors
  },
  computed: {
    address: {
      get () {
        return this.$store.state.order.address;
      },
      set (value) {
        this.$store.commit('order/setAddress', value);
      }
    },
    isAddressOk: {
      get() {
        return this.$store.state.order.isAddressOk;
      }
    },
    errors: {
      get () {
        return this.$store.state.order.errors;
      },
    },
  },
}
</script>
